<app-data-set #dataSet [dataSource]="dataSource" defaultPresentationMode="table" [rowId]="rowId">
	@if (canAddRoles) {
		<app-data-set-toolbar>
			<div *appActionGroup style="display: flex; flex: 1; justify-content: center">
				<app-data-set-action-button
					icon="add"
					label="Create New Role"
					i18n-label="@@companyRolesTable-CreateNewRoleIcon"
					data-automation-id="navigate-to-role-button"
					(click)="navigateToAddRole()"
				></app-data-set-action-button>
			</div>
		</app-data-set-toolbar>
	}

	<app-data-set-content>
		<app-data-set-table-view>
			@if (
				loadingService.isLoading(getMyRolesLoadingKey) ||
				loadingService.isLoading(getCompanyRolesByCompanyIdLoadingKey) ||
				!finishedLoadingInitData
			) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="
					loadingService.isLoading(getMyRolesLoadingKey) ||
					loadingService.isLoading(getCompanyRolesByCompanyIdLoadingKey) ||
					!finishedLoadingInitData
				"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>
				<ng-container matColumnDef="roleName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyRolesTable-roleName">Role Name</th>
					<td mat-cell *matCellDef="let row">{{ row.role.name }}</td>
				</ng-container>
				<ng-container matColumnDef="creatorName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyRolesTable-createdBy">Created By</th>
					<td mat-cell *matCellDef="let row">{{ row.role.creatorName }}</td>
				</ng-container>
				<ng-container matColumnDef="userCount">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyRolesTable-users">Users</th>
					<td mat-cell *matCellDef="let row">{{ row.userCount }}</td>
				</ng-container>
				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						@if (canClickRole(row)) {
							<app-data-set-table-menu [menu]="menu" [row]="row"></app-data-set-table-menu>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(click)="canClickRole(row) ? onRowSelected(row.role) : null"
					[class.disabled-row]="!canClickRole(row)"
					[attr.data-automation-id]="'role-' + row.id + '-row'"
				></tr>
			</table>

			<mat-menu #menu="matMenu">
				<ng-template matMenuContent let-row="row">
					@if (canEditRoles && !row.role.isUniversal) {
						<button
							mat-menu-item
							(click)="onRowSelected(row.role, edit)"
							i18n="@@companyRolesTable-edit"
							data-automation-id="company-roles-edit-button"
						>
							Edit
						</button>
					}
					@if (!canEditRoles || row.role.isUniversal) {
						<button
							mat-menu-item
							(click)="onRowSelected(row.role, edit)"
							i18n="@@companyRolesTable-view"
							data-automation-id="company-roles-edit-view-button"
						>
							View
						</button>
					}
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
